<template>
  <div>
    <page-title icon="card" title_text="دستگاه کارتخوان"></page-title>

    <div id="card-boxs" class="row mx-auto text-center">
      <!-- <div
        @mouseenter="show_coming_soon('novin')"
        @mouseleave="hide_coming_soon('novin')"
        class="col-12 col-md my-2"
      >
        <div
          :class="[
            'bg-white shadow-sm p-2 h-100 gateway-tab',
            currentTab === 'novin' ? 'border border-success active-tab' : '',
          ]"
          style="border-radius: 10px; border-width: 2px !important"
        >
          <span
            :class="['px-2', currentTab === 'novin' ? 'text-success' : 'text-secondary']"
          >
            پرداخت نوین آرین
          </span>
        </div>
        <div class="triangle-down d-none d-md-block" v-if="currentTab === 'novin'"></div>
      </div> -->

      <div
        @mouseenter="show_coming_soon('pasargad')"
        @mouseleave="hide_coming_soon('pasargad')"
        class="col-12 col-md"
      >
        <div
        class="d-flex align-items-center justify-content-center"
          :class="[
            'bg-white shadow-sm p-2 h-100 gateway-tab',
            currentTab === 'pasargad' ? 'border border-success active-tab' : '',
          ]"
          style="border-radius: 10px; border-width: 2px !important"
        >
          <div class="ribbon shadow-sm" id="coming_soon_pasargad" style="display: none">
            به زودی
          </div>
          <span
            :class="[
              'px-2',
              currentTab === 'pasargad' ? 'text-success' : 'text-secondary',
            ]"
          >
            پرداخت الکترونیک پاسارگاد
          </span>
        </div>
        <div
          class="triangle-down d-none d-md-block"
          v-if="currentTab === 'pasargad'"
        ></div>
      </div>

      <div
        @mouseenter="show_coming_soon('kish')"
        @mouseleave="hide_coming_soon('kish')"
        class="col-12 col-md"
      >
        <div
        class="d-flex align-items-center justify-content-center"
          :class="[
            'bg-white shadow-sm p-3 gateway-tab',
            currentTab === 'kish' ? 'border border-success active-tab' : '',
          ]"
          style="border-radius: 10px; border-width: 2px !important"
        >
          <div class="ribbon shadow-sm" id="coming_soon_kish" style="display: none">
            به زودی
          </div>
          <span
            :class="['px-2', currentTab === 'kish' ? 'text-success' : 'text-secondary']"
          >
            کارت اعتباری ایران‌کیش
          </span>
        </div>
        <div class="triangle-down d-none d-md-block" v-if="currentTab === 'kish'"></div>
      </div>

      <div
        @mouseenter="show_coming_soon('sepehr')"
        @mouseleave="hide_coming_soon('sepehr')"
        class="col-12 col-md"
      >
        <div
        class="d-flex align-items-center justify-content-center"
          :class="[
            'bg-white shadow-sm p-2 h-100 gateway-tab',
            currentTab === 'sepehr' ? 'border border-success active-tab' : '',
          ]"
          style="border-radius: 10px; border-width: 2px !important"
        >
          <div class="ribbon shadow-sm" id="coming_soon_sepehr" style="display: none">
            به زودی
          </div>
          <span
            :class="['px-2', currentTab === 'sepehr' ? 'text-success' : 'text-secondary']"
          >
            پرداخت الکترونیک سپهر
          </span>
        </div>
        <div class="triangle-down d-none d-md-block" v-if="currentTab === 'sepehr'"></div>
      </div>

      <div
        @mouseenter="show_coming_soon('novin')"
        @mouseleave="hide_coming_soon('novin')"
        class="col-12 col-md"
      >
        <div
        class="d-flex align-items-center justify-content-center"
          :class="[
            'bg-white shadow-sm p-2 h-100 gateway-tab',
            currentTab === 'novin' ? 'border border-success active-tab' : '',
          ]"
          style="border-radius: 10px; border-width: 2px !important"
        >
          <div class="ribbon shadow-sm" id="coming_soon_novin" style="display: none">
            به زودی
          </div>
          <span
            :class="[
              'px-2',
              currentTab === 'novin' ? 'text-success' : 'text-secondary',
            ]"
          >
            پرداخت نوین آرین
          </span>
        </div>
        <div
          class="triangle-down d-none d-md-block"
          v-if="currentTab === 'novin'"
        ></div>
      </div>

      
      <div
        @mouseenter="show_coming_soon('mellat')"
        @mouseleave="hide_coming_soon('mellat')"
        class="col-12 col-md"
      >
        <div
        class="d-flex align-items-center justify-content-center"
          :class="[
            'bg-white shadow-sm p-3 gateway-tab',
            currentTab === 'mellat' ? 'border border-success active-tab' : '',
          ]"
          style="border-radius: 10px; border-width: 2px !important"
        >
          <div class="ribbon shadow-sm" id="coming_soon_mellat" style="display: none">
            به زودی
          </div>
          <span
            :class="['px-2', currentTab === 'mellat' ? 'text-success' : 'text-secondary']"
          >
            به پرداخت ملت
          </span>
        </div>
        <div class="triangle-down d-none d-md-block" v-if="currentTab === 'mellat'"></div>
      </div>
    </div>

    <div>
      <div>
        <div
          class="p-3 mt-3 bg-white text-center shadow-sm w-100"
          style="border-radius: 10px"
        >
          <div
            class="rounded-circle border border-success p-2 mx-auto"
            style="
              width: fit-content;
              border-width: 3px !important;
              max-width: max-content;
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              fill="#00bea5"
              height="48"
              shape-rendering="geometricPrecision"
              text-rendering="geometricPrecision"
              image-rendering="optimizeQuality"
              fill-rule="evenodd"
              clip-rule="evenodd"
              viewBox="0 0 264 512.03"
            >
              <path
                fill-rule="nonzero"
                d="M6.28 321.17C4.1 313.06 2.54 307 1.5 298.79.47 290.7 0 280.9 0 265.48v-93.19c0-8.54 3.28-16.3 8.55-21.93 5.28-5.65 12.56-9.16 20.56-9.16h204.97c8.02 0 15.33 3.52 20.62 9.18 5.29 5.65 8.57 13.45 8.57 22v93.43c1.2 14.57.82 26.29-.45 36.35-1.29 10.29-3.46 18.73-5.79 26.68-11.45 39.01-10.77 73.44-10.01 111.85.2 10.57.42 21.41.42 31.07l-.01.3c.37 12.74-2.38 22.78-8.63 29.75-6.33 7.06-15.9 10.6-29.05 10.19l-158.47.01c-12.47.35-21.1-3.29-26.75-10.01-5.62-6.68-7.89-16.05-7.83-27.28l-.02-73.07c0-16.77-.49-29.05-2.01-40.93-1.52-11.88-4.14-23.7-8.39-39.55zM116.77 73.86c0-6.76-3.25-12.75-8.28-16.49 5.03-3.75 8.28-9.74 8.28-16.49 0-11.35-9.2-20.56-20.55-20.56-11.35 0-20.55 9.21-20.55 20.56 0 6.75 3.26 12.74 8.29 16.49-5.03 3.74-8.29 9.73-8.29 16.49 0 11.35 9.2 20.55 20.55 20.55 11.35 0 20.55-9.2 20.55-20.55zm103.75 53.75V14.13c0-7.78-6.36-14.13-14.13-14.13H57.63C49.86 0 43.5 6.36 43.5 14.13v113.48h8.18V14.13c0-3.25 2.69-5.95 5.95-5.95h84.1v119.43h48.35V8.18h16.31c3.26 0 5.94 2.69 5.94 5.95v113.48h8.19zm-108.35 0v-21.18c0-5.24-10.41-5.23-10.41 0v21.18h10.41zm-21.48 0v-10.57c0-5.24-10.42-5.23-10.42 0v10.57h10.42zm22.1 304.55h38.43v42.42h-38.43v-42.42zm-60.94 0h38.42v42.42H51.85v-42.42zm121.89-66.86h38.43v109.09h-38.43V365.3zm-60.95 0h38.43v42.42h-38.43V365.3zm-60.94 0h38.42v42.42H51.85V365.3zm121.89-66.86h38.43v42.41h-38.43v-42.41zm-60.95 0h38.43v42.41h-38.43v-42.41zm-60.94 0h38.42v42.41H51.85v-42.41zm-6.36-116.09h173.04c1.92 0 3.5 1.69 3.5 3.75v76.27c0 2.06-1.58 3.75-3.5 3.75H45.49c-1.92 0-3.5-1.69-3.5-3.75V186.1c0-2.06 1.57-3.75 3.5-3.75zM12.77 297.18c.92 7.22 2.4 12.96 4.47 20.68 4.37 16.27 7.07 28.58 8.7 41.25 1.62 12.68 2.14 25.41 2.14 42.54l-.02 73.09c-.05 8.33 1.38 14.98 4.94 19.21 3.39 4.04 9.15 6.21 17.94 5.97l.65-.04h158.16l.18.03c9.79.33 16.56-1.91 20.63-6.44 4.02-4.48 5.77-11.59 5.51-21.02l-.04-.69c0-11.71-.19-21.4-.37-30.84-.78-39.47-1.48-74.85 10.5-115.68 2.2-7.48 4.23-15.34 5.39-24.64 1.17-9.29 1.52-20.15.41-33.72a6.5 6.5 0 0 1-.09-1.09v-93.41c0-5.25-2.01-10.02-5.23-13.47-3.22-3.44-7.67-5.57-12.56-5.57H29.11c-4.87 0-9.3 2.12-12.5 5.54-3.21 3.44-5.21 8.18-5.21 13.41v93.19c0 15.04.44 24.34 1.37 31.7z"
              ></path>
            </svg>
          </div>

          <div class="my-4">
            <a
              class="btn btn-success px-5"
              id="btn-success-in-gateways"
              style="border-radius: 20px"
              type="button"
            >
              ثبت ترمینال
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageTitle from "@/components/main/components/pageTitle";
import $ from "jquery";

export default {
  components: { PageTitle },
  data() {
    return {
      currentTab: "",
    };
  },
  methods: {
    gotoTab(selected_tab) {
      this.currentTab = selected_tab;
    },
    hide_coming_soon(index) {
      $(`#coming_soon_${index}`).slideUp();
    },
    show_coming_soon(index) {
      $(`#coming_soon_${index}`).slideDown();
    },
    copyText(text, index) {
      navigator.clipboard.writeText(text);
      let el = document.getElementById("btn_" + index);
      el.classList.remove("fa-copy");
      el.classList.add("fa-check");

      setTimeout(() => {
        el.classList.remove("fa-check");
        el.classList.add("fa-copy");
      }, 1500);
    },
  },
};
</script>

<style scoped>

@media screen and (max-width:678px){
  #card-boxs div{
    font-size: 12px;
    margin: 0.3rem 0 0 0;
    padding: 0;
  }
}
</style>
